import React, { useContext } from "react";
import { Checkbox } from "../../../view/Checkbox";
import { deepCopy } from "../../../utils";
import { TableContext } from "../../../index";
//import dots from "../../../_resources/img/vdots.png";



function PortsTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td>
                {data.port}
            </td>
            <td>
                {data.status}
            </td>
            <td>
                {data.service}
            </td>  
            <td>
                {/* <div className="btn oct_btn-tool-table">
                    <i className="fas fa-ellipsis-v"></i>
                    <img src={dots} alt="Icon" className="oct_vertical_align" />
                </div> */}
            </td>          
        </tr>
    )
}

export default PortsTableRow;
